import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, Button, Alert } from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import { UploadCloud, Check, X } from 'react-feather';


const UploadAnnexure = ({ onFileSelect, title = "Upload Annexure", fileType = "" }) => {
    const {
        acceptedFiles,
        isDragActive,
        isDragAccept,
        isDragReject,
        getRootProps,
        getInputProps
    } = useDropzone({
        accept: {
            'application/pdf': []
        }, // ✅ Only allow PDFs
        maxFiles: 1, // Optional: limit to 1 file
        maxSize: 2 * 1024 * 1024, // 2MB max
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length > 0 && onFileSelect) {
                onFileSelect(acceptedFiles[0]);
            }
        }
    });

    const files = acceptedFiles.map((file) => (
        <ListGroupItem
            className="font-size-sm px-3 py-2 text-primary d-flex justify-content-between align-items-center"
            key={file.path}>
            <span>{file.path}</span>
            <span className="badge badge-pill bg-neutral-warning text-warning">
                {file.size} bytes
            </span>
        </ListGroupItem>
    ));
    return (
        <>
            <div className='annexure_mar'>
                <div className="dropzone">
                    <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
                        <input {...getInputProps()} />
                        <div className="dropzone-inner-wrapper">
                            {isDragAccept && (
                                <div>
                                    <div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white">
                                        <Check className="d-50" />
                                    </div>
                                    <div className="font-size-sm text-success">
                                        PDF file accepted!
                                    </div>
                                </div>
                            )}
                            {isDragReject && (
                                <div>
                                    <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
                                        <X className="d-50" />
                                    </div>
                                    <div className="font-size-sm text-danger">
                                        Only PDF files are allowed!
                                    </div>
                                </div>
                            )}
                            {!isDragActive && (
                                <div className="upload_detail text-center">
                                    <i className="bi bi-upload upload-icon-large" style={{ fontSize: '2.5rem', color: '#FF5722' }}></i>
                                    <h4 className="upload-title" style={{ fontSize: '1rem', margin: '12px 0 8px' }}>{title}</h4>
                                    {files.length <= 0 ? (
                                        <>
                                            <div className="upload-hint mt-1" style={{ fontSize: '0.85rem', color: '#666' }}>
                                                Drag & drop or click to upload
                                            </div>
                                        </>
                                    ) : (
                                        <div className='mt-2'>
                                            <ListGroup className="font-size-sm">{files}</ListGroup>
                                        </div>
                                    )}
                                </div>
                            )}


                        </div>
                    </div>
                </div>

                {/* <div>
                    <div className="font-weight-bold my-4 text-uppercase text-dark font-size-sm text-center">
                        Uploaded Files
                    </div>
                    {files.length <= 0 ? (
                        <div className="text-info text-center font-size-sm">
                            Uploaded files will appear here.
                        </div>
                    ) : (
                        <div>
                            <Alert color="success" className="text-center mb-3">
                                You have uploaded <b>{files.length}</b> file(s)!
                            </Alert>
                            <ListGroup className="font-size-sm">{files}</ListGroup>
                        </div>
                    )}
                </div> */}
            </div>
        </>
    )
}

export default UploadAnnexure;